import React, { useEffect, useState, useCallback } from 'react';
import { Section } from '../layout';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import {
  EditButtonStyle,
  EditonBlur,
  EditonFocus,
  EditonMouseEnter,
  EditonMouseLeave,
  localeTextGrid,
} from "../../constants";
import { useNavigate } from "react-router-dom";
import { Loader } from '../../components/utils';

import { DataGrid } from '@mui/x-data-grid';
import { ThemeProvider, createTheme } from '@mui/material';
import { useStateContext } from '../../context/ContextProvider';
import { media } from '../../server';
import {truncateTitle} from "../../middleware/truncateTitle"
import  {truncateText,renderText} from "../hooks/TextVeiw"
import { Button } from "@mui/material";
import CategoryFilter from './utils/CategoryFilter';
import { getFillterVideoCategorys } from '../../redux/actions/videoCategory';
function DAllCategoryVideos() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentDir } = useStateContext();
  
  const { isLoading,  FilterVideoCategorys,pagination} = useSelector((state) => state.VideoCategory);

  const [titleAr, setTitleAr] = useState('');
  const [titleEn, setTitleEn] = useState('');
  const navigate = useNavigate();
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });

  const page = paginationModel.page;
  const limit = paginationModel.pageSize;


  useEffect(() => {

    dispatch(getFillterVideoCategorys(page, limit, titleAr, titleEn ));
  }, [page, limit, titleAr, titleEn,dispatch]);

 

  const UpdateCategoryHandeler = (id) => {

    navigate(`/EditVideoCategoryPage/${id}`);
  };

  const theme = createTheme({
    direction: currentDir
  });
  const totalPages = pagination?.totalPages || 0;
  const totalItems = pagination?.totalItems || 0; // إضافة هذا إذا كان الخادم يعيد إجمالي العناصر
  const columns = [
    {
      field: 'titleAr',
      headerName: t('Title (Ar)'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
            <p className="font-medium text-sm font-kufi">{truncateTitle(params.value , 3)}</p>
          </div>
        )
      }
    },
    {
      field: 'titleEn',
      headerName:  t('Title (En)') ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
                <p className="font-medium text-sm font-kufi">{truncateTitle(params.value , 3)}</p>
          </div>
        )
      }
    },
    {
      field: 'textAr',
      headerName:   t('Text (Ar)'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 250,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex font-medium text-sm font-kufi items-center pt-4">
              {renderText(
          truncateText(
            params.value,
            4 // عدد الكلمات المطلوبة للقص
          )
        ," font-medium text-sm font-kufi items-center")}  
          </div>
        )
      }
    },
    {
      field: 'textEn',
      headerName:   t('Text (En)'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 250,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
                <p className="font-medium text-sm font-kufi">{truncateTitle(params.value ,4)}</p>
          </div>
        )
      }
    },

    {
      field: 'Image',
      headerName: t('Image'),
      headerClassName: 'font-semibold text-sm font-kufi',
      minWidth: 100,
      flex: 0.7,
      filterable: false, // تعطيل الفلتر لهذا العمود
      renderCell: (params) => {
        return (
          <div
            style={{
              borderRadius: "10%",
              padding:"2px",
              width: "50px",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50px"
            }}
          >
            <img
              src={`${media}${params.value}`}
              alt="Product Image"
              style={{
                height: "100%",
                width: "auto",
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          </div>
        );
      },
    },
    {
      field: 'actions',
      headerName: t('Actions')  ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 100,
      filterable: false, // تعطيل الفلتر لهذا العمود
      renderCell: (params) => {
        return (<>
   <div className="flex pt-2 w-[100ox] gap-2 items-center ">
 
<Button className="rounded-full"
           style={EditButtonStyle}
           onMouseEnter={EditonMouseEnter}
           onMouseLeave={EditonMouseLeave}
           onFocus={EditonFocus}
           onBlur={EditonBlur} 
        onClick={() => UpdateCategoryHandeler(params.row._id)}
        >
         <span className='body-2'>{t("Edit")}</span> 
</Button>
          
   </div>
        
         </>
        );
      }
    },
  ];


  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (

          <div className="flex-col  lg:p-16 py-14 px-5 w-full items-start ">
            <h2 className="h2 text-color-1 text-center  dark:text-tcolor-1 mb-4 md:mb-8">{t("Videos Categories")}</h2>
            <CategoryFilter titleAr={titleAr} setTitleAr={setTitleAr} titleEn={titleEn} setTitleEn={setTitleEn} />
           
            <div className=" items-center  relative justify-center  md:m-10 mt-24 p-2 md:p-10 h-auto bg-white rounded-3xl">
  <ThemeProvider theme={theme}>
    <div style={{ width: '100%', overflowX: 'auto' }}>
                <DataGrid
                  rows={FilterVideoCategorys}
                  columns={columns}
                  disableRowSelectionOnClick
                  sx={{ minWidth: '1200px' }}       
                  pagination
                  paginationMode="server"
                  rowCount={totalItems} // Total number of items
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  pageSizeOptions={[paginationModel.pageSize]}
                  getRowId={(row) => row._id} // Use _id as the unique identifier
                  localeText={localeTextGrid} // تمرير الترجمات
                />
          </div>
  </ThemeProvider>
</div></div>
        
      )}
    </>
  );
}

export default DAllCategoryVideos;